import React, { useEffect, useState } from "react";
import axios from "axios";

const SubjectManagement = () => {
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [isedit, setIsedit] = useState(false);
  const [editingSubjectId, setEditingSubjectId] = useState(null);

  const [formData, setFormData] = useState({
    SubjectId: "",
    SubjectName: "",
    coursesids: [],
    SubjectCaption: "",
    SubjectDesc: ""
  });

  useEffect(() => {
    fetchSubjects();
    fetchCourses();
  }, []);

  useEffect(() => {
    if (!isedit) {
      const generatedId = generateSubjectId();
      setFormData((prev) => ({
        ...prev,
        SubjectId: generatedId,
      }));
    }
  }, [subjects]);

  const fetchCourses = async () => {
    try {
      const res = await axios.get("/api/new/courses");
      setCourses(res.data);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  const fetchSubjects = async () => {
    try {
      const res = await axios.get("/api/subjects");
      setSubjects(res.data);
    } catch (error) {
      console.error("Error fetching subjects:", error);
    }
  };

  const generateSubjectId = () => {
    const prefix = "SUB";
    const count = subjects.length + 1;
    return `${prefix}-${count}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const submitData = { ...formData };

      if (!isedit) {
        await axios.post("/api/subject", submitData);
        alert("Software created!");
      } else {
        await axios.put(`/api/subject/${editingSubjectId}`, submitData);
        alert("Software updated!");
      }

      fetchSubjects();
      resetForm();
      document.getElementById("closeModalBtn")?.click();
    } catch (err) {
      console.error("Error submitting subject:", err);
      alert("Submission failed.");
    }
  };

  const handleEdit = (subject) => {
    setIsedit(true);
    const courseIds = subject.coursesids.map((course) =>
      typeof course === "object" && course !== null ? course._id : course
    );

    setFormData({
      SubjectId: subject.SubjectId || "",
      SubjectName: subject.SubjectName || "",
      coursesids: courseIds,
      SubjectCaption: subject.SubjectCaption || "",
      SubjectDesc: subject.SubjectDesc || ""
    });

    setEditingSubjectId(subject._id);
  };

  const handleDelete = async (subjectId) => {
    if (window.confirm("Are you sure you want to delete this subject?")) {
      try {
        await axios.delete(`/api/subject/${subjectId}`);
        alert("Deleted successfully!");
        fetchSubjects();
      } catch (error) {
        console.error("Error deleting subject:", error);
        alert("Failed to delete subject.");
      }
    }
  };

  const resetForm = () => {
    setIsedit(false);
    setFormData({
      SubjectId: generateSubjectId(),
      SubjectName: "",
      coursesids: [],
      SubjectCaption: "",
      SubjectDesc: ""
    });
  };

  const handleCheckboxChange = (e, courseId) => {
    const isChecked = e.target.checked;
    setFormData((prev) => ({
      ...prev,
      coursesids: isChecked
        ? [...prev.coursesids, courseId]
        : prev.coursesids.filter((id) => id !== courseId)
    }));
  };

  return (
    <div className="container">
      <h3 className="my-3">Software Management</h3>
      <button
        className="btn btn-primary mb-3"
        data-bs-toggle="modal"
        data-bs-target="#editModal"
        onClick={resetForm}
      >
        Add Software
      </button>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Software Name</th>
            <th>Courses</th>
            <th>Caption</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {subjects.map((subject) => (
            <tr key={subject._id}>
              <td>{subject.SubjectName}</td>
              <td>
                {(subject.coursesids || [])
                  .map((c) => c.CourseName || "Unknown")
                  .join(", ")}
              </td>
              <td>{subject.SubjectCaption}</td>
              <td>
                <button
                  className="btn btn-info btn-sm me-2"
                  data-bs-toggle="modal"
                  data-bs-target="#editModal"
                  onClick={() => handleEdit(subject)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(subject._id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal */}
      <div className="modal fade" id="editModal" tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">{isedit ? "Edit" : "Add"} Software</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="closeModalBtn"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Software Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.SubjectName}
                      onChange={(e) =>
                        setFormData({ ...formData, SubjectName: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Caption</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.SubjectCaption}
                      onChange={(e) =>
                        setFormData({ ...formData, SubjectCaption: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="col-md-12 mb-3">
                    <label className="form-label">Description</label>
                    <textarea
                      className="form-control"
                      rows={3}
                      value={formData.SubjectDesc}
                      onChange={(e) =>
                        setFormData({ ...formData, SubjectDesc: e.target.value })
                      }
                      required
                    ></textarea>
                  </div>
                  <div className="col-md-12 mb-3">
                    <label className="form-label">Courses</label>
                    <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                      {courses.map((course) => (
                        <div className="form-check" key={course._id}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`course-${course._id}`}
                            checked={formData.coursesids.includes(course._id)}
                            onChange={(e) => handleCheckboxChange(e, course._id)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`course-${course._id}`}
                          >
                            {course.CourseName}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  {isedit ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubjectManagement;

